// src/components/onboarding/VoiceSelectionCard.tsx
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { PlayCircle, CheckCircle } from 'lucide-react';

// VoiceOption structure remains the same
export interface VoiceOption {
  id: string;
  name: string;
  description: string; // Added description based on user feedback
  provider?: string;
  sampleUrl?: string;
  // Removed avatarUrl
}

interface VoiceSelectionCardProps {
  voice: VoiceOption;
  isSelected: boolean;
  onSelect: (voice: VoiceOption) => void;
  onPlaySample?: (voice: VoiceOption) => void;
}

const VoiceSelectionCard: React.FC<VoiceSelectionCardProps> = ({ voice, isSelected, onSelect, onPlaySample }) => {
  const handlePlay = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onPlaySample) {
       onPlaySample(voice);
       console.log("Playing sample for:", voice.name);
       // Add audio playback logic here (e.g., using Howler.js or Web Audio API)
    } else {
        console.warn("Play sample handler not provided for:", voice.name);
    }
  };

  return (
    <Card
      className={`cursor-pointer transition-all duration-200 flex flex-col h-full ${ // Added flex classes for consistent height
        isSelected ? 'border-blue-600 ring-2 ring-blue-500 dark:border-blue-400' : 'border-gray-200 dark:border-gray-700 hover:shadow-md'
      }`}
      onClick={() => onSelect(voice)}
    >
      <CardHeader className="p-4 relative text-center">
         {isSelected && (
             <CheckCircle size={20} className="absolute top-2 right-2 text-blue-600 dark:text-blue-400" />
         )}
         {/* Removed Avatar Logic */}
         <CardTitle className="text-base font-semibold text-gray-800 dark:text-gray-100">{voice.name}</CardTitle>
          {/* Display Description */}
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 px-2">{voice.description}</p>
      </CardHeader>
      {/* Keep CardContent minimal or remove if not needed */}
      <CardContent className="p-0 flex-grow">
         {/* Placeholder if more details needed later */}
      </CardContent>
      <CardFooter className="p-3 flex justify-center border-t border-gray-100 dark:border-gray-700 mt-auto"> {/* Ensure footer is at bottom */}
        <Button
          variant="ghost"
          size="sm"
          onClick={handlePlay}
          disabled={!onPlaySample || !voice.sampleUrl}
          aria-label={`Play sample for ${voice.name}`}
        >
          <PlayCircle size={16} className="mr-1" />
          Play Sample
        </Button>
      </CardFooter>
    </Card>
  );
};

export default VoiceSelectionCard;